module.exports.trickster = {
  vi: {
    title: 'Kẻ lừa lọc (Trickster) trong Avalon: kết quả phe giả và Merlin',
    description:
      'Kẻ lừa lọc thuộc phe Thiện hay Ác trong Avalon? Tìm hiểu vì sao kiểm tra cho kết quả Thiện, vì sao Merlin vẫn thấy Ác và điểm khác Kẻ gây rối.',
    keywords: ['Kẻ lừa lọc', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Trapaceiro em Avalon: falsa lealdade e Merlin',
    description:
      'O Trapaceiro é bom ou mau em Avalon? Saiba por que as verificações mostram bem, por que Merlin o vê e como difere do Encrenqueiro.',
    keywords: ['Trapaceiro', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Trickster in Avalon: False Loyalty & Merlin',
    description:
      'Is the Trickster good or evil in Avalon? Learn why loyalty checks show good, why Merlin still sees evil and how Trickster differs from Troublemaker.',
    keywords: ['Trickster', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Трикстер в Авалоне: ложная лояльность и Мерлин',
    description:
      'Трикстер добрый или злой? Почему проверки показывают добро, видит ли его Мерлин и чем Трикстер отличается от Траблмейкера в Авалоне.',
    keywords: ['Трикстер', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆騙子：假陣營查驗與梅林視野',
    description: '阿瓦隆騙子是好人還是壞人？了解為何查驗顯示好人、梅林為何仍能看到他，以及與麻煩友的相反機制。',
    keywords: ['騙子', '角色', '規則', '建議'],
  },
  'zh-CN': {
    title: '阿瓦隆骗子：假阵营查验与梅林视野',
    description: '阿瓦隆骗子是好人还是坏人？了解为何查验显示好人、梅林为何仍能看到他，以及与麻烦友的相反机制。',
    keywords: ['骗子', '角色', '规则', '建议'],
  },
  es: {
    title: 'Tramposo en Avalon: falsa lealtad y Merlín',
    description:
      '¿El Tramposo es bueno o malo en Avalon? Por qué las comprobaciones muestran bien, por qué Merlín lo ve y su diferencia con el Problematizador.',
    keywords: ['Tramposo', 'Rol', 'Reglas', 'Consejos'],
  },
};
